export default () => {
    return [
        {
            path: '/myTasks',
            name: 'myTasks',
            component: () => import('./views/myTasks.vue'),
        },
    ];
};
